import React from 'react'

import i18n from 'i18n-literally'
import { useConnect } from 'redux-bundler-hook'

import { Box } from '@mui/material'

import {
  Field,
  Form,
  Formik,
  useFormikContext,
} from 'formik'

import createLogger from '~/src/Lib/Logging'
import { PUBLIC_ROUTES, REGISTER_ROUTES } from '~/src/Routes/constants'
import {
  getRegisterGatewayInitialValues,
  getRegisterGatewayValidationSchema,
} from '~/src/Routes/Register/utils'
import Gateway from '~/src/UI/Icons/Gateway'
import Button from '~/src/UI/Shared/Button'
import { FormikTextField } from '~/src/UI/Shared/Form/TextField'
import T from '~/src/UI/Shared/Typography'

const displayName = 'RegisterGateway'
const logger = createLogger(displayName)

const sx = {
  instructions: {
    maxWidth: 460,
    textAlign: 'center'
  },
  inputs: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '1rem',
    minWidth: 300,
    gap: '1ch'
  },
  registerButton: {
    padding: '0 2rem'
  }
}
const INSTRUCTIONS = i18n`To create an account for using AROYA GO, you need to register your Gateway with the serial number and key, printed on the bottom of the product.`

const RegisterGateway = () => {
  const { values, isValid } = useFormikContext()

  return (
    <Form>
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
        <Box display="flex" gap="1ch" alignItems="center" margin="1rem">
          <Gateway color="primary" />
          <T.H3>{i18n`Register your Gateway`}</T.H3>
        </Box>
        <Box sx={sx.instructions}>
          <T>
            {INSTRUCTIONS}
            <Button variant="text">{i18n`Where to find this?`}</Button>
          </T>
        </Box>
        <Box sx={sx.inputs}>
          <Field
            required
            fullWidth
            name="serialNumber"
            label={i18n`Serial Number`}
            type="text"
            component={FormikTextField}
          />
          <Field
            required
            fullWidth
            name="key"
            label={i18n`Key`}
            type="text"
            component={FormikTextField}
          />
        </Box>
        <Box mt="6rem" width={300} display="flex" gap="1ch" justifyContent="flex-end">
          <Button variant="text" href={`${PUBLIC_ROUTES.LOGIN}`}>
            {i18n`Cancel`}
          </Button>
          <Button
            type="submit"
            disabled={!(values.serialNumber && values.key && isValid)}
            sx={sx.registerButton}
          >
            {i18n`Register`}
          </Button>
        </Box>
      </Box>
    </Form>
  )
}

RegisterGateway.displayName = displayName

const Connected = () => {
  const { doUpdateUrl } = useConnect('doUpdateUrl')
  const initialValues = getRegisterGatewayInitialValues()
  const validationSchema = getRegisterGatewayValidationSchema()

  const handleSubmit = async () => {
    // TODO: hit endpoint and if success save token to use it later
    // If success move to sucess gateway
    await doUpdateUrl(REGISTER_ROUTES.GATEWAY_SUCCESS)
  }

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      <RegisterGateway />
    </Formik>
  )
}

const Memoized = React.memo(Connected)
export default Memoized
